import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { getDataFromResponse } from '../constant/utils/react-query-utils/getDataFromResponse';
import { setApiError } from '../store/slices/apiError.slice';
import { ErrorSource } from '../constant/model/api/api';
import { handleApiError } from '../constant/utils/error.helper';
import { getCoachDemographics } from '../api/user.api';
import { 
    updateCoachEthnicityOptions, 
    updateCoachGenderOptions, 
    updateCoachSexualOrientationOptions } from '../store/slices/coachDemographicSlice';
import { coachDemographicKeys } from '../constant/query-keys/coachDemographicKeys';

export const useCoachDemographicsQuery = () => {
  const dispatch = useDispatch();
  
  return useQuery(
    coachDemographicKeys.lists(),
    async () => {
      const response = await getCoachDemographics();
      const data = getDataFromResponse(response);
      if (data.statusCode && data.statusCode !== 200) {
        const error = new Error('Coach Demographics request failed') as any;
        error.response = {
          data: data,
          status: data.statusCode,
        };
        throw error;
      }
      
      return data;
    },
    {
      onSuccess: (data) => {
        dispatch(updateCoachGenderOptions(data.data.coachGenderOptions));
        dispatch(updateCoachEthnicityOptions(data.data.coachEthnicityOptions));
        dispatch(updateCoachSexualOrientationOptions(data.data.coachSexualOrientationOptions));
      },
      onError: (error) => {
        const errorDetails = handleApiError(error);
        dispatch(setApiError({
          source: ErrorSource.COACH_DEMOGRAPHICS,
          error: {
            message: errorDetails.message || 'Failed to fetch demographics',
            statusCode: errorDetails.status || 500,
            stack: errorDetails.stack || ''
          }
        }));
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
};